import { styled } from '@mui/material/styles'
import { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { Tooltip } from '@mui/material'
import theme from 'theme'

export const ErrorTooltip = styled(
  ({ className, ...props }: TooltipProps & { isChip?: boolean; isSquare?: boolean }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)({
  [`& .${tooltipClasses.tooltip}`]: {
    display: 'flex',
    marginTop: '0 !important',
    padding: `${theme.spacing.small}px`,
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: theme.attributes.borderRadius.quaternary,
    border: `1px solid ${theme.colors.controlBorder}`,
    background: '#4E4E4E',
    minWidth: '253px',

    "html[data-theme='light'] &": {
      background: theme.colors.tooltipBg,
      borderColor: theme.colors.dropdownBorder
    }
  },
  '.text-container': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    textAlign: 'start',

    '.tooltip-title': {
      color: theme.colors.foreground,
      fontFamily: theme.typography.fontFamily.primary,
      fontSize: theme.typography.fontSize.xLarge,
      fontStyle: 'normal',
      fontWeight: theme.typography.fontWeight.bold,
      lineHeight: '24px',
      letterSpacing: '0.1px'
    },

    '.description-container': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: `${theme.spacing.small}px`,

      '.tooltip-text': {
        color: theme.colors.foreground,
        fontFamily: theme.typography.fontFamily.primary,
        fontSize: theme.typography.fontSize.large,
        fontStyle: 'normal',
        fontWeight: theme.typography.fontWeight.normal,
        lineHeight: '20px',
        letterSpacing: '0.25px',

        'ul li': {
          color: theme.colors.foreground,
          fontFamily: theme.typography.fontFamily.primary,
          fontSize: theme.typography.fontSize.large,
          fontStyle: 'normal',
          fontWeight: theme.typography.fontWeight.normal,
          lineHeight: '20px',
          letterSpacing: '0.25px'
        }
      }
    }
  },
  '.tooltip-wrapper': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: `${theme.spacing.xSmall}px`,
    width: '100%',

    '.instance-name-container': {
      display: 'flex',
      alignItems: 'center',
      gap: `${theme.spacing.xSmall}px`,

      img: {
        width: '24px',
        height: '24px',
        borderRadius: theme.attributes.borderRadius.circle,
        minWidth: 'unset !important'
      },

      '.instance-name': {
        color: theme.colors.foreground,
        fontFamily: theme.typography.fontFamily.primary,
        fontSize: theme.typography.fontSize.large,
        fontStyle: 'normal',
        fontWeight: theme.typography.fontWeight.thick,
        lineHeight: 'normal'
      }
    },

    '.error-description-container': {
      display: 'flex',
      alignItems: 'center',
      gap: `${theme.spacing.xSmall}px`,

      '.error-icon': {
        width: '24px',
        height: '24px',
        borderRadius: theme.attributes.borderRadius.circle
      },

      '.error-text': {
        color: theme.baseColors.info[50],
        fontFamily: theme.typography.fontFamily.primary,
        fontSize: theme.typography.fontSize.large,
        fontStyle: 'normal',
        fontWeight: theme.typography.fontWeight.normal,
        lineHeight: 'normal'
      }
    }
  }
})

export const linkSx = {
  whiteSpace: 'nowrap',
  fontFamily: theme.typography.fontFamily.primary,
  fontSize: theme.typography.fontSize.medium,
  fontWeight: theme.typography.fontWeight.bold,
  lineHeight: '16px',
  letterSpacing: '0.5px',
  textDecoration: 'underline',
  cursor: 'pointer'
}
